<!--
/*******************************************************************************
*@ 화면명     : SmsFrstCertn
*@ 화면설명   : SMS 최초 본인인증
*@ 사용전문   : RBF0409E40 - 고객정보조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!--"MOTP-01-05-01-01": "본인 인증"-->
    <!-- "MOTP-01-05-01-02": "등록된 휴대폰 번호를 확인하시고 다시 한번 휴대폰 번호 전체를 입력하여 주시기 바랍니다. "-->
    <div class="scroll">
      <contents-header
        :bg-type="true"
        :no-radius="true"
        :tabs="true"
        title="MOTP-01-05-06-01"
        description="MOTP-01-05-05-02"
      >
        <template #tab>
          <div class="tabs bg-type" id="tabs">
            <button
              class="tab-button tab-button--type1"
              v-for="(tab, index) in tabs"
              :class="{ active: currentTab === index, disabled : index == isTabDisabled }"
              @click="FN000(index)"
              :key="index"
            >
              <i class="icon icon-attestation" />
              <span class="btn-text">{{ tab }}</span>
            </button>
          </div>
        </template>
      </contents-header>

      <article class="contents">
        <div v-show="currentTab === 0">
          <div class="form">
            <div class="form-row">
              <div class="item-tit">{{ /*등록된 휴대폰 번호*/ $t("MOTP-01-05-01-03") }}</div>
              <div class="item-desc">
                <div class="phone-number">
                  {{ getSendCetrNo.in.cphnNo.slice(getSendCetrNo.in.cphnNo.length * -1, getSendCetrNo.in.cphnNo.length - 8) }}
                  <span
                    class="round"
                  ></span>
                  <span class="round"></span>
                  {{ getSendCetrNo.in.cphnNo.slice(-6, getSendCetrNo.in.cphnNo.length - 4) }}
                  <span
                    class="round"
                  ></span>
                  <span class="round"></span>
                  {{ getSendCetrNo.in.cphnNo.slice(-2, getSendCetrNo.in.cphnNo.length) }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*휴대폰 번호 입력*/ $t("MOTP-01-05-01-04") }}</div>
              <div class="item-desc form-multi-group">
                <div>
                  <div class="form-select-field">
                    <div
                      class="form-select"
                      :class="[{ disabled: false }, { readonly: false }]"
                      @click="type = !type"
                    >
                      <span
                        class="option"
                        :class="[{ placeholder: false }]"
                      >{{ getSendCetrNo.in.certnNatnlCd_text !== "" ? getSendCetrNo.in.certnNatnlCd_text : "-" }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-text-field">
                  <div class="input-text-field">
                    <input
                      type="tel"
                      id="name"
                      class="form-control"
                      placeholder="Ex.01012345678"
                      :value="getSendCetrNo.in.certnCphnNo"
                      @input="$store._mutations['auth/commMotpCertn/mut002_commMotpCertn'][0]({ key: 'certnCphnNo', value: $event.currentTarget.value })"
                    />
                  </div>
                </div>
              </div>
              <div class="item-desc">
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="checkbox01"
                    id="checkbox01"
                    class="form-check-input"
                    v-on:click="FN001($event)"
                    :checked="getSendCetrNo.in.certnCnsntYn === '1' ? 'checked' : ''"
                  />
                  <label
                    for="checkbox01"
                    class="form-check-label"
                  >{{ /*인증 문자 수신에 동의합니다.*/ $t("MOTP-01-05-01-05") }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="currentTab === 1">
          <div class="form">
            <div class="form-row">
              <div class="item-tit">{{ /*-이메일 주소*/ $t("MOTP-01-05-06-03") }}</div>
              <div class="item-desc form-multi-group">
                <div class="item-desc">
                  <div class="form-text-field email">
                    <div class="input-text-field">
                      <input
                        type="text"
                        id="name"
                        class="form-control"
                        :value="getRBF0409E40.out.success.emad1 === '' ? '-' : getRBF0409E40.out.success.emad1"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="item-desc">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="checkbox01"
                      id="checkbox01"
                      class="form-check-input"
                      v-on:click="FN002($event)"
                      :checked="getRBF0409E40.out.success.emailRecvCnsntYn === '1' ? 'checked' : ''"
                    />
                    <label
                      for="checkbox01"
                      class="form-check-label"
                    >{{ /*인증 메일 수신에 동의합니다.*/ $t("MOTP-01-05-06-12") }}</label>
                  </div>
                  <div class="info info-help" @click="type4 = true">
                    <i class="icon icon-help" />
                    {{ /*-이메일 주소가 변경 되었나요?*/ $t("MOTP-01-05-06-04") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form">
          <!-- 인증코드 요청 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
          <div class="form-row">
            <button
              :class="FN003()"
              v-on:click="FN004()"
            >{{ /*인증코드 요청, 인증코드 재발송 */ this.isFirsrSend === true ? $t("MOTP-01-05-06-05") : $t("MOTP-01-05-06-06") }}</button>
          </div>

          <div class="validate">
            <article v-if="getSendCetrNo.messageForTimeOut === true">
              <!-- <article>인증 코드 입력 시간이 초과하였습니다.</article>
              <article>인증 코드 발송 요청을 다시해주시기 바랍니다.</article>-->
              <!-- "MOTP-01-05-09-02": "인증코드 입력 시간이 초과하였습니다.<br/>인증 코드 발송 요청을 다시해주시기  바랍니다."-->
              <span v-html="$t('MOTP-01-05-09-02')"></span>
            </article>
            <!-- 로컬/개발환경에서만 내려옴.. -->
            <article
              v-if="getSendCetrNo.out.success.certnNo.length === 6"
            >(local/dev 인증코드) {{ getSendCetrNo.out.success.certnNo }}</article>
          </div>
          <!-- 인증코드 요청 [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->

          <!-- 인증완료 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
          <article v-if="getSendCetrNoConfirm.in.certnNoSerno !== ''">
            <div class="form-row">
              <div class="item-tit">{{ /*인증코드 입력*/ $t("MOTP-01-05-05-07") }}</div>
              <div class="item-desc">
                <div class="form-text-field">
                  <!-- "MOTP-01-05-06-08": "수신된 인증코드 6자리를 입력하세요."-->
                  <div class="input-text-field timer-type2">
                    <input
                      type="tel"
                      id="name"
                      class="form-control"
                      :placeholder="$t('MOTP-01-05-05-08')"
                      maxlength="6"
                      :value="getSendCetrNoConfirm.in.certnNo"
                      @input="$store._mutations['auth/commMotpCertn/mut001_commMotpCertn'][0]({ key: 'certnNo', value: $event.currentTarget.value })"
                    />
                    <span class="timer">
                      {{
                      Math.floor(this.$store.state.auth.commMotpCertn.sendTime / 60) + " : " + _.padStart(Math.floor(this.$store.state.auth.commMotpCertn.sendTime % 60), 2, "0")
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <button
                :class="`btn lg inline ${getSendCetrNoConfirm.in.certnNoSerno !== '' && getSendCetrNoConfirm.in.certnNo.length === 6 ? 'normal' : 'disabled'}`"
                v-on:click="FN005()"
              >{{ /*인증완료*/ $t("MOTP-01-05-01-11") }}</button>
            </div>
            <article v-if="currentTab === 0">
              <div
                v-if="getSendCetrNoConfirm.out.success.certnNoCnfrmRsultDstcd === '2'"
                class="form-row confirm"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="checkbox02"
                    id="checkbox02"
                    class="form-check-input"
                    v-on:click="FN006($event)"
                    :checked="getSendCetrNo.in.recvCnsntYn === '1' ? 'checked' : ''"
                  />
                  <label for="checkbox02" class="form-check-label">
                    <!-- 인증이 완료된 휴대폰 번호를 저장하시겠습니까?
                    <br />(인증 문자 수신 동의도 함께 진행)-->
                    <!-- "MOTP-01-05-01-12": "인증이 완료된 휴대폰 번호를 저장합니다.<br/>(추후 인증 문자 수신 동의 포함)"-->
                    <span v-html="$t('MOTP-01-05-01-12')"></span>
                  </label>
                </div>
              </div>
            </article>
          </article>
          <!-- 인증코드 [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
        </div>
      </article>
    </div>

    <!-- 이전/인증하기 O [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <div class="btn-area--full fixed">
      <button class="btn md gray" v-on:click="FN007">{{ /*이전*/ $t("MOTP-01-05-01-13") }}</button>
      <button
        :class="`btn md ${getSendCetrNoConfirm.out.success.certnNoCnfrmRsultDstcd === '2' ? 'normal' : 'disabled'}`"
        v-on:click="FN008"
      >{{ /*다음*/ $t("MOTP-01-05-01-14") }}</button>
    </div>
    <!-- 이전/인증하기 E [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->

    <!-- Toast 인증번호가 발송되었습니다. -->
    <Toast />

    <!-- 인증국가코드 action sheet 들어 가는 곳 ■■■■■■■■■■■■■■■■■■■ -->
    <!-- "MOTP-01-05-02-01": "국가 선택"-->
    <action-sheet
      :opened.sync="type"
      :action-header="true"
      :action-footer="true"
      :use-top-border="true"
      title="MOTP-01-05-02-01"
      class="action-sheet action-sheet--list-type"
    >
      <template #content>
        <ul>
          <li
            v-for="(v, i) in getSmsFrstCertn[$store.state.siteCode].certnNatnlCdArr"
            :key="i"
            v-on:click="FN009(v)"
          >{{ v.selectText }}</li>
        </ul>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          v-on:click="type = !type"
        >{{ /*확인*/ $t("MOTP-01-05-03-03") }}</button>
      </template>
    </action-sheet>

    <!-- 인증문자가 수신되지 않으셨나요? action sheet 들어 가는 곳 ■■■■■■■■■■■■■■■■■■■ -->
    <!--"MOTP-01-05-01-10": "※ 인증 문자가 수신되지 않으셨나요?"-->
    <action-sheet
      :opened.sync="type2"
      :action-header="true"
      :action-footer="true"
      :use-top-border="true"
      title="MOTP-01-05-01-10"
      class="action-sheet action-sheet--list-type"
    >
      <template #content>{{ /*인증문자가 수신되지 않으셨나요?*/ $t("MOTP-01-05-01-10") }}</template>
      <template #footer>
        <button
          class="btn bottom positive"
          v-on:click="type2 = !type2"
        >{{ /*확인*/ $t("MOTP-01-05-03-03") }}</button>
      </template>
    </action-sheet>

    <!-- 휴대폰 번호 저장 동의 유도 팝업 들어가는 곳 ■■■■■■■■■■■■■■■■■■■ -->
    <modal-pop
      :opened.sync="type3"
      :no-negative-button="true"
      confirm="MCOM-0000003"
      cancel="MCOM-0000002"
      @confirm="FN010"
      @cancel="FN011"
    >
      <template #content>
        <div>
          <strong class="text-info">
            <!-- 휴대폰 번호 저장에 동의를 하시면 추후
            <br />간소화된 휴대폰 인증이 가능합니다.
            <br />휴대폰 번호를 저장하시겠습니까?-->
            <span v-html="$t('MOTP-01-05-04-02')"></span>
          </strong>
        </div>
      </template>
    </modal-pop>

    <!--// end -->

    <!-- action sheet 들어 가는 곳 -->
    <!-- "MOTP-01-05-08-01": "휴대폰/이메일 변경 안내"-->
    <sms-email-info-pop :opened.sync="type4" />
  </article>
</template>
<style type="scss" scoped></style>
<script>
import { mapGetters, mapActions } from "vuex";
//import ContentsHeader from "@/components/page/common/ContentsHeader.vue";
import Common from "@/components/basic/Common";
import Toast from "@/components/page/auth/Toast";
import SmsEmailInfoPop from "@/components/page/auth/SmsEmailInfoPop";

export default {
  name: "SmsFrstCertn",
  extends: Common,
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
    beforeRouterName: {
      type: String,
      required: true,
    },
  },
  created() {
    this.$log.info("SmsFrstCertn - SMS 최초 본인인증");

    //등록된 전화번호 없으면 Email탭으로
    if (_.isNil(this.getSendCetrNo.in.cphnNo) || _.isEmpty(this.getSendCetrNo.in.cphnNo)) {
      this.currentTab = 1;
      this.isTabDisabled = 0
    } else if (this.getRBF0409E40.out.success.emad1 == "") {
      this.isTabDisabled = 1
    }

    if (_.isNil(this.getSendCetrNo.in.certnNatnlCd) || _.isEmpty(this.getSendCetrNo.in.certnNatnlCd)) {
      // selectbox 초기값..?
      this.FN009(this.getSmsFrstCertn[this.$store.state.siteCode].certnNatnlCdArr[0]);
    }
  },
  mounted() {},
  updated() {},
  data() {
    return {
      currentTab: 0,
      tabs: ["Mobile", "E-Mail"],
      items: [],
      type: false,
      type2: false,
      type3: false,
      type4: false,
      isFirsrSend: true,
      isTabDisabled : -1
    };
  },
  components: {
    SmsEmailInfoPop,
    Toast,
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getRBF0409E40", "getSendCetrNo", "getSendCetrNoConfirm", "getSmsFrstCertn"]),
  },
  methods: {
    ...mapActions("auth/commMotpCertn", ["act002_commMotpCertn", "act006_commMotpCertn", "act007_commMotpCertn", "act009_commMotpCertn", "act_setComponent"]),

    /**
     * 탭클릭시..
     */
    FN000: function (index) {
      if (this.isTabDisabled != index) {
        this.currentTab = index;
        this.isFirsrSend = true;
        this.act006_commMotpCertn();
      }
    },

    /**
     * 인증문자 수신 동의
     */
    FN001: function (e) {
      if (e.currentTarget.checked === true) {
        this.$store._mutations["auth/commMotpCertn/mut004_commMotpCertn"][0]({ key: "recvCnsntYn", value: "1" });
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnCnsntYn = "1";
      } else {
        this.$store._mutations["auth/commMotpCertn/mut004_commMotpCertn"][0]({ key: "recvCnsntYn", value: "0" });
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnCnsntYn = "0";
      }
    },

    /**
     * Email 수신동의 checkbox 클릭시..
     */
    FN002: function (e) {
      if (e.currentTarget.checked === true) {
        this.$store._mutations["auth/commMotpCertn/mut002_commMotpCertn"][0]({ key: "recvCnsntYn", value: "1" });
        this.getRBF0409E40.out.success.emailRecvCnsntYn = "1";
      } else {
        this.$store._mutations["auth/commMotpCertn/mut002_commMotpCertn"][0]({ key: "recvCnsntYn", value: "0" });
        this.getRBF0409E40.out.success.emailRecvCnsntYn = "0";
      }
    },

    /**
     * 인증코드 요청 버튼 class 컨트롤
     */
    FN003: function () {
      let rtn = "btn lg inline disabled";
      // sms
      if (this.currentTab === 0) {
        if (
          !_.isEmpty(this.getSendCetrNo.in.cphnNo) &&
          !_.isEmpty(this.getSendCetrNo.in.certnNatnlCd) &&
          !_.isEmpty(this.getSendCetrNo.in.certnCphnNo) &&
          this.getSendCetrNo.in.certnCnsntYn == "1"
        ) {
          rtn = "btn lg inline";
        }
        // email
      } else if (this.currentTab === 1) {
        if (this.getRBF0409E40.out.success.emad1 !== "" && this.getRBF0409E40.out.success.emailRecvCnsntYn == "1") {
          rtn = "btn lg inline";
        }
      }
      return rtn;
    },

    /**
     * 인증코드 요청(인증코드 재발송) 버튼 클릭시..
     */
    FN004: function () {
      if (this.currentTab === 0) {
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.msgSendPtrnCd = "1";

        if (!(this.getSendCetrNo.in.cphnNo.length > 7 && this.getSendCetrNo.in.certnCphnNo.length > 7)) {
          this.$store.state.error.active = true;
          this.$store.state.error.errCode = "NUMBER";
          this.$store.state.error.errMsg = this.$t("MOTP-01-05-03-02"); /*등록된 휴대폰 번호와 입력한 번호가 일치하지 않습니다.*/
          return;
        }

        // 전화번호 뒷자리 검증
        const cphnNo_checkNum = this.getSendCetrNo.in.cphnNo.slice(-7, this.getSendCetrNo.in.cphnNo.length);
        const certnCphnNo_checkNum = this.getSendCetrNo.in.certnCphnNo.slice(-7, this.getSendCetrNo.in.certnCphnNo.length);

        if (cphnNo_checkNum !== certnCphnNo_checkNum) {
          this.$store.state.error.active = true;
          this.$store.state.error.errCode = "NUMBER";
          this.$store.state.error.errMsg = this.$t("MOTP-01-05-03-02"); /*등록된 휴대폰 번호와 입력한 번호가 일치하지 않습니다.*/
          return;
        }
      } else if (this.currentTab === 1) {
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.msgSendPtrnCd = "2";
      }

      this.isFirsrSend = false;
      this.act002_commMotpCertn();
    },

    /**
     * 인증완료 버튼 클릭시..
     */
    FN005: async function () {
      this.$store.state.auth.commMotpCertn.sendCetrNoConfirm.in.bizDscd = this.bizDscd;
      await this.act007_commMotpCertn();
    },

    /**
     * 인증된 휴대폰 저장 여부 클릭시..
     */
    FN006: function (e) {
      if (e.currentTarget.checked === true) {
        this.$store._mutations["auth/commMotpCertn/mut004_commMotpCertn"][0]({ key: "recvCnsntYn", value: "1" });
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.recvCnsntYn = "1";
      } else {
        this.$store._mutations["auth/commMotpCertn/mut004_commMotpCertn"][0]({ key: "recvCnsntYn", value: "0" });
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.recvCnsntYn = "0";
      }
    },

    /**
     * 이전버튼 클릭시..
     */
    FN007: function () {
      this.act_setComponent("SelfCertnComm");
    },
    /**
     * 다음버튼 클릭시..
     * 고객연락처상세정보변경 거래 후 다음으로..
     */
    FN008: async function () {
      if (this.currentTab === 0) {
        if (this.getSendCetrNo.in.recvCnsntYn === "1") {
          //const rtn = "success";
          const rtn = await this.act009_commMotpCertn();
          if (rtn === "success" && !_.isNil(this.successFnc)) {
            this.successFnc();
          }
        } else {
          this.type3 = true;
        }
      } else if (this.currentTab === 1) {
        this.successFnc();
      }
    },

    /**
     * 셀렉트 박스 선택시.
     */
    FN009: function (v) {
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnNatnlCd = v.value;
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnNatnlCd_text = v.text;
      this.type = false;
    },

    /**
     * 휴대폰 인증번호 저장 유도 팝업에서 예 클릭시..
     */
    FN010: function () {
      this.$store._mutations["auth/commMotpCertn/mut004_commMotpCertn"][0]({ key: "recvCnsntYn", value: "1" });
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.recvCnsntYn = "1";
      this.type3 = false;
    },
    /**
     * 휴대폰 인증번호 저장 유도 팝업에서 아니오 클릭시..
     * 고객연락처상세정보변경 없이 다음으로..
     */
    FN011: function () {
      if (!_.isNil(this.successFnc)) {
        this.successFnc();
      }
    },
  },
};
</script>